import { addDays, isAfter, startOfDay } from "date-fns";
import { fromZonedTime, toZonedTime } from "date-fns-tz";

const startOfLocalDay = (date: Date, timeZone: string) =>
  startOfDay(toZonedTime(date, timeZone));

export const toLocalMidnightUtc = (date: Date, timeZone: string) =>
  fromZonedTime(startOfLocalDay(date, timeZone), timeZone);

export const getTomorrowAtLocalMidnightUtc = (timeZone: string) => {
  const zonedTomorrow = addDays(startOfLocalDay(new Date(), timeZone), 1);
  return fromZonedTime(zonedTomorrow, timeZone);
};

export const isFutureLocalDate = (date: Date | null | undefined, timeZone: string) =>
  date == null || isAfter(startOfLocalDay(date, timeZone), startOfLocalDay(new Date(), timeZone));
